import type { PopoverMenuItem } from "@kontextwerk/web-sdk/ui/overlay/popover/types"
import { mdiArrowRightBold, mdiCloseCircleOutline, mdiDelete } from "@mdi/js"
import {
  SCHEDULING_ACTION_TOOLTIP_CLASS,
  schedulingActionTooltips,
} from "../../../../../../../../../../_shared/_logic/action-tooltips"

export const primaryScheduleEventAction = ({
  showSaveAction,
  canConfirmAppointment,
  showRescheduleAction,
}: {
  showSaveAction: boolean
  canConfirmAppointment: boolean
  showRescheduleAction: boolean
}): "submit" | "confirm" | "reschedule" | null => {
  if (showSaveAction) return "submit"

  if (canConfirmAppointment) return "confirm"

  return showRescheduleAction ? "reschedule" : null
}

/** Relocate existing secondary commands without changing their eligibility or handlers. */
export const buildScheduleEventHeaderActions = (state: {
  event: ScheduleEvent
  forceReadOnly: boolean
  isAppointment: boolean
  showSaveAction: boolean
  canConfirmAppointment: boolean
  showRescheduleAction: boolean
  canMarkNoShow: boolean
  saving: boolean
  deleting: boolean
  initiatingReschedule: boolean
  canceling: boolean
  confirming: boolean
  onDelete: () => void
  onStartReschedule: () => void
  onMarkNoShow: () => void
}): PopoverMenuItem[] => {
  const actions: PopoverMenuItem[] = []

  if (state.event.id && !state.forceReadOnly && !state.isAppointment) {
    actions.push({
      id: "delete",
      label: state.deleting ? "Lösche…" : "Eintrag löschen",
      icon: mdiDelete,
      disabled: state.saving || state.deleting,
      tone: "danger",
      reason: schedulingActionTooltips.eventDelete,
      onClick: state.onDelete,
    })
  }

  if (state.showRescheduleAction && primaryScheduleEventAction(state) !== "reschedule") {
    actions.push({
      id: "reschedule",
      label: state.initiatingReschedule ? "Starte…" : "Verschieben",
      icon: mdiArrowRightBold,
      disabled: state.saving || state.deleting || state.initiatingReschedule,
      reason: schedulingActionTooltips.eventReschedule,
      onClick: state.onStartReschedule,
    })
  }

  if (state.canMarkNoShow) {
    actions.push({
      id: "no-show",
      label: state.canceling ? "Setze…" : "Nicht stattgefunden",
      icon: mdiCloseCircleOutline,
      disabled: state.canceling || state.saving || state.deleting || state.confirming,
      reason: schedulingActionTooltips.eventNoShow,
      onClick: state.onMarkNoShow,
    })
  }

  return actions.map((action) => ({ ...action, tooltipClassName: SCHEDULING_ACTION_TOOLTIP_CLASS }))
}
